// Data.js

const MemoryGameEventPlannerData = [
   {
    id: 1,
    name: "wedding",
    type: "picture",
    itemImg: "weddingCake.png",
    matched: false,
},
{
    id: 2,
    name: "wedding",
    type: "text",
    itemName: "Wedding",
    matched: false,
},
{
    id: 3,
    name: "birthdayParty",
    type: "picture",
    itemImg: "birthdayCake.png",
    matched: false,
},
{
    id: 4,
    name: "birthdayParty",
    type: "text",
    itemName: "Birthday Party",
    matched: false,
},
{
    id: 5,
    name: "babyShower",
    type: "picture",
    itemImg: "babyBottle.png",
    matched: false,
},
{
    id: 6,
    name: "babyShower",
    type: "text",
    itemName: "Baby Shower",
    matched: false,
},
{
    id: 7,
    name: "bridalShower",
    type: "picture",
    itemImg: "bridalShowerGames.png",
    matched: false,
},
{
    id: 8,
    name: "bridalShower",
    type: "text",
    itemName: "Bridal Shower",
    matched: false,
},
{
    id: 9,
    name: "fourthJuly",
    type: "picture",
    itemImg: "fireWorks.png",
    matched: false,
},
{
    id: 10,
    name: "fourthJuly",
    type: "text",
    itemName: "4th Of July Party",
    matched: false,
},
{
    id: 11,
    name: "graduationParty",
    type: "picture",
    itemImg: "graduationHat.png",
    matched: false,
},
{
    id: 12,
    name: "graduationParty",
    type: "text",
    itemName: "Graduation Party",
    matched: false,
},
{
    id: 13,
    name: "retirementParty",
    type: "picture",
    itemImg: "retirementSign.png",
    matched: false,
},
{
    id: 14,
    name: "retirementParty",
    type: "text",
    itemName: "Retirement Party",
    matched: false,
},
{
    id: 15,
    name: "anniversaryParty",
    type: "picture",
    itemImg: "anniversary.png",
    matched: false,
},
{
    id: 16,
    name: "anniversaryParty",
    type: "text",
    itemName: "Anniversary Party",
    matched: false,
},
{
    id: 17,
    name: "movieNight",
    type: "picture",
    itemImg: "popcorn.png",
    matched: false,
},
{
    id: 18,
    name: "movieNight",
    type: "text",
    itemName: "Movie Night",
    matched: false,
},
{
    id: 19,
    name: "valentinesDay",
    type: "picture",
    itemImg: "valentines.png",
    matched: false,
},
{
    id: 20,
    name: "valentinesDay",
    type: "text",
    itemName: "Valentine’s Day Event",
    matched: false,
},
{
    id: 21,
    name: "halloweenParty",
    type: "picture",
    itemImg: "pumpkin.png",
    matched: false,
},
{
    id: 22,
    name: "halloweenParty",
    type: "text",
    itemName: "Halloween Party",
    matched: false,
},
{
    id: 23,
    name: "stPatricksDay",
    type: "picture",
    itemImg: "leprachaun.png",
    matched: false,
},
{
    id: 24,
    name: "stPatricksDay",
    type: "text",
    itemName: "St. Patrick’s Day Event",
    matched: false,
},
{
    id: 25,
    name: "artShow",
    type: "picture",
    itemImg: "artEasel.png",
    matched: false,
},
{
    id: 26,
    name: "artShow",
    type: "text",
    itemName: "Art Show",
    matched: false,
},
{
    id: 27,
    name: "thanksgivingEvent",
    type: "picture",
    itemImg: "thanksgiving.png",
    matched: false,
},
{
    id: 28,
    name: "thanksgivingEvent",
    type: "text",
    itemName: "ThanksGivng Event",
    matched: false,
},
{
    id: 29,
    name: "iceCreamSocial",
    type: "picture",
    itemImg: "iceCreamCone.png",
    matched: false,
},
{
    id: 30,
    name: "iceCreamSocial",
    type: "text",
    itemName: "Ice Cream Social",
    matched: false,
},

{
    id: 31,
    name: "newYearsEve",
    type: "picture",
    itemImg: "newYears.png",
    matched: false,
},
{
    id: 32,
    name: "newYearsEve",
    type: "text",
    itemName: "New Year’s Eve Event",
    matched: false,
},
{
    id: 33,
    name: "poolParty",
    type: "picture",
    itemImg: "poolToy.png",
    matched: false,
},
{
    id: 34,
    name: "poolParty",
    type: "text",
    itemName: "Pool Party",
    matched: false,
},
{
    id: 35,
    name: "picnicEvent",
    type: "picture",
    itemImg: "picnicBasket.png",
    matched: false,
},
{
    id: 36,
    name: "picnicEvent",
    type: "text",
    itemName: "Picnic Event",
    matched: false,
},
{
    id: 37,
    name: "treasureHunt",
    type: "picture",
    itemImg: "treasureMap.png",
    matched: false,
},
{
    id: 38,
    name: "treasureHunt",
    type: "text",
    itemName: "Treasure Hunt",
    matched: false,
},
{
    id: 39,
    name: "prom",
    type: "picture",
    itemImg: "promBanner.png",
    matched: false,
},
{
    id: 40,
    name: "prom",
    type: "text",
    itemName: "Prom",
    matched: false,
},
{
    id: 41,
    name: "spaceParty",
    type: "picture",
    itemImg: "planets.png",
    matched: false,
},
{
    id: 42,
    name: "spaceParty",
    type: "text",
    itemName: "Space Themed Party",
    matched: false,
},
{
    id: 43,
    name: "scienceFair",
    type: "picture",
    itemImg: "microscope.png",
    matched: false,
},
{
    id: 44,
    name: "scienceFair",
    type: "text",
    itemName: "Science Fair",
    matched: false,
},
/*
{
    id: 47,
    name: "grandOpening",
    type: "picture",
    itemImg: "ribbonCutting.png",
    matched: false,
},
{
    id: 48,
    name: "grandOpening",
    type: "text",
    itemName: "Grand Opening",
    matched: false,
},
/*

{
    id: 49,
    name: "familyReunion",
    type: "picture",
    itemImg: "groupPhoto.png",
    matched: false,
},
{
    id: 50,
    name: "familyReunion",
    type: "text",
    itemName: "Family Reunion",
    matched: false,
},
{
    id: 51,
    name: "welcomeParty",
    type: "picture",
    itemImg: "welcomeSign.png",
    matched: false,
},
{
    id: 52,
    name: "welcomeParty",
    type: "text",
    itemName: "Welcome Party",
    matched: false,
},
{
    id: 53,
    name: "farewellParty",
    type: "picture",
    itemImg: "farewellBanner.png",
    matched: false,
},
{
    id: 54,
    name: "farewellParty",
    type: "text",
    itemName: "Farewell Party",
    matched: false,
},
{
    id: 55,
    name: "communityFestival",
    type: "picture",
    itemImg: "outdoorStage.png",
    matched: false,
},
{
    id: 56,
    name: "communityFestival",
    type: "text",
    itemName: "Community Festival",
    matched: false,
},
{
    id: 57,
    name: "backToSchoolEvent",
    type: "picture",
    itemImg: "schoolDecor.png",
    matched: false,
},
{
    id: 58,
    name: "backToSchoolEvent",
    type: "text",
    itemName: "Back to School Event",
    matched: false,
},
{
    id: 59,
    name: "themedParty",
    type: "picture",
    itemImg: "themedDecor.png",
    matched: false,
},
{
    id: 60,
    name: "themedParty",
    type: "text",
    itemName: "Themed Party",
    matched: false,
},

*/
    
];
export default MemoryGameEventPlannerData;